import React, { useState, useEffect } from "react";
import { TabWrapper, TabItem } from "./styles";

const Tabs = ({ defaultActiveKey, children, onChange }) => {
  const [activeKey, setActiveKey] = useState(defaultActiveKey);

  const handleTabClick = (key) => {
    if (key !== activeKey) {
      setActiveKey(key);
      if (onChange) {
        onChange(key);
      }
    }
  };

  useEffect(() => {
    setActiveKey(defaultActiveKey);
  }, [defaultActiveKey]);

  const validChildren = React.Children.toArray(children).filter(Boolean);

  return (
    <>
      <TabWrapper>
        {validChildren.map((child) => {
          if (child.type === Tab) {
            const { eventKey, label } = child.props;
            return (
              <TabItem key={`tab_${label}`} active={activeKey == eventKey} onClick={() => handleTabClick(eventKey)}>
                {label}
              </TabItem>
            );
          }
          return null;
        })}
      </TabWrapper>
      {validChildren.map((child) => {
        if (child.type === Tab && child.props.eventKey == activeKey) {
          return child.props.children;
        }
        return null;
      })}
    </>
  );
};

const Tab = ({ eventKey, label, children }) => (
  <div eventKey={eventKey}>
    <div>{label}</div>
    {children}
  </div>
);

export { Tabs, Tab };
